import React from 'react'
import FontAwesome from 'react-fontawesome'
import * as config from 'config'
import { connect } from 'react-redux'
import { isMobile } from './../../../../../services/breakpoints.service'
import { withRouter } from 'react-router-dom'
import { ImagePicker } from 'react-file-picker'
import { toastActions } from './../../../../../actions'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { convertFileToDataURLviaFileReader } from '../../../../../helpers/image.helper'
import {
	StyledContainer,
	StyledImagePicker,
	StyledProductImage
} from './styled-components'

const dims = {
	minWidth: 1,
	maxWidth: 1000,
	minHeight: 1,
	maxHeight: 1000
}

const extensions = ['jpg', 'jpeg', 'png']
const message = `A extensão deve ser ${extensions
	.join(', ')
	.replace(/^(.*)(,)([^,]+)$/g, '$1 ou$3')}`

class ProductImagesComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			images: [],
			mainImageIndex: 0
		}

		props.sendData(() => ({
			images: this.state.images,
			mainImageIndex: this.state.mainImageIndex
		}))
		this.removeImage = removeImage.bind(this)
		this.onImagePick = onImagePick.bind(this)
		this.renderImages = renderImages.bind(this)
		this.setMainImage = setMainImage.bind(this)
	}

	componentWillReceiveProps(nextProps) {
		const previousInitialData = this.props.initialData || {}
		const nextInitialData = nextProps.initialData || {}

		const nextInitialImages = nextInitialData.productImages || []
		const previousInitialImages = previousInitialData.productImages || []

		if (previousInitialImages.length != nextInitialImages.length) {
			const images = []
			const { mainImageIndex } = nextInitialData || 0
			nextInitialImages.forEach(image => {
				const url = `${config.contentUrl}loja/produto/${image}`
				convertFileToDataURLviaFileReader(url, base64Image => {
					images.push(base64Image)
					this.setState({ images, mainImageIndex })
				})
			})
		}
	}

	render() {
		const { toastError } = this.props

		return (
			<StyledContainer>
				<ImagePicker
					dims={dims}
					className="item"
					extensions={extensions}
					onChange={this.onImagePick}
					onError={() => toastError({ message })}
					style={{ width: isMobile() ? '50%' : '25%' }}>
					<StyledImagePicker>
						<FontAwesome name="plus" size="2x" />
						<span className="blue" style={{ textAlign: 'center' }}>
							Adicionar
							{isMobile() ? <br /> : ' '}
							imagem
						</span>
					</StyledImagePicker>
				</ImagePicker>
				{this.renderImages()}
			</StyledContainer>
		)
	}
}

function removeImage(indexToRemove) {
	const { mainImageIndex } = this.state

	const images = this.state.images.filter(
		(_, index) => index !== indexToRemove
	)

	const nextMainImageIndex =
		mainImageIndex == indexToRemove
			? Math.max(0, mainImageIndex - 1)
			: mainImageIndex

	this.setState({
		images,
		mainImageIndex: nextMainImageIndex
	})
}

function onImagePick(base64) {
	const { images } = this.state
	images.push(base64)
	this.setState({ images })
}

function renderImages() {
	const { mainImageIndex, images } = this.state
	return images.map((image, index) => {
		const isMainImage = mainImageIndex == index
		return (
			<StyledProductImage
				key={index}
				className="item"
				onClick={() => this.setMainImage(index)}>
				<img src={image} />
				<FontAwesome
					size="2x"
					name={isMainImage ? 'star' : ''}
					className={isMainImage ? 'main-image' : ''}
				/>
				<FontAwesome
					size="2x"
					name="plus"
					className="close-sign"
					onClick={e => {
						this.removeImage(index)
						e.stopPropagation()
					}}
				/>
			</StyledProductImage>
		)
	})
}

function setMainImage(mainImageIndex) {
	this.props.toastSuccess({ message: 'Imagem principal selecionada' })
	this.setState({ mainImageIndex })
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const ProductImages = withRouter(
	connect(
		null,
		mapDispatchToProps
	)(ProductImagesComponent)
)

export default ProductImages
